import { patchPromise } from '@core/js/backbone/promise';

import * as constants from './constants';
import { TServerSendRequest } from './types';
export * from './hooks';

// should be deleted after moving to server request hooks
export const send = <T = object>(request: TServerSendRequest<T>) => patchPromise(window[constants.SEND_SYMBOL](request));
